module.exports = __webpack_public_path__ + "static/media/Group 3877.6e978788.svg";